import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CommonState {
  isTermsAccepted: boolean;
  submitSuccess: boolean;
  checkoutErrorMessage: string | null;
  purchaseCompleted: boolean;
  mandatoryComponents: string[];
  CallMetaApi: boolean;
  salesTaxEnabled: boolean;
  calculatedFeeEnabled?: boolean;
  variantIdToAddIsTermsAccepted: string;
  mandatoryProduct: string;
  hideProduct: string;
  hideProductThankYou: string;
  isValidShippingForm?: boolean;
  isPaymentByPaypal?: boolean;
  IsSMSConsent: boolean;
  IsEmailConsent: boolean;
}

const initialState: CommonState = {
  isTermsAccepted: false,
  submitSuccess: false,
  salesTaxEnabled: false,
  calculatedFeeEnabled: false,
  checkoutErrorMessage: null,
  purchaseCompleted: false,
  mandatoryComponents: [],
  CallMetaApi: false,
  variantIdToAddIsTermsAccepted: '',
  mandatoryProduct: '',
  hideProduct: '',
  hideProductThankYou: '',
  isValidShippingForm: false,
  isPaymentByPaypal: false,
  IsSMSConsent: false,
  IsEmailConsent: false,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsTermsAccepted(state, action: PayloadAction<boolean>) {
      state.isTermsAccepted = action.payload;
    },
    setCallMetaApi(state, action: PayloadAction<boolean>) {
      state.CallMetaApi = action.payload;
    },
    setSalexTaxEnabled(state, action: PayloadAction<boolean>) {
      state.salesTaxEnabled = action.payload;
    },
    setCalculatedFeeEnabled(state, action: PayloadAction<boolean>) {
      state.calculatedFeeEnabled = action.payload;
    },
    setSubmitSuccess(state, action: PayloadAction<boolean>) {
      state.submitSuccess = action.payload;
    },
    setCheckoutErrorMessage(state, action: PayloadAction<string | null>) {
      state.checkoutErrorMessage = action.payload;
    },
    setPurchaseCompleted(state, action: PayloadAction<boolean>) {
      state.purchaseCompleted = action.payload;
    },
    setMandatoryComponents(state, action: PayloadAction<string[]>) {
      state.mandatoryComponents = action.payload;
    },
    setVariantIdToAddIsTermsAccepted(state, action: PayloadAction<string>) {
      state.variantIdToAddIsTermsAccepted = action.payload;
    },
    setMandatoryProduct(state, action: PayloadAction<string>) {
      state.mandatoryProduct = action.payload;
    },
    setHideProduct(state, action: PayloadAction<string>) {
      state.hideProduct = action.payload;
    },
    setHideProductThankYou(state, action: PayloadAction<string>) {
      state.hideProductThankYou = action.payload;
    },
    setIsValidShippingForm(state, action: PayloadAction<boolean>) {
      state.isValidShippingForm = action.payload;
    },
    setIsPaymentByPaypal(state, action: PayloadAction<boolean>) {
      state.isPaymentByPaypal = action.payload;
    },
    setIsSMSConsent(state, action: PayloadAction<boolean>) {
      state.IsSMSConsent = action.payload;
    },
    setIsEmailConsent(state, action: PayloadAction<boolean>) {
      state.IsEmailConsent = action.payload;
    },
  },
});

export const {
  setIsTermsAccepted,
  setSubmitSuccess,
  setCheckoutErrorMessage,
  setPurchaseCompleted,
  setMandatoryComponents,
  setCallMetaApi,
  setSalexTaxEnabled,
  setCalculatedFeeEnabled,
  setVariantIdToAddIsTermsAccepted,
  setMandatoryProduct,
  setHideProduct,
  setHideProductThankYou,
  setIsValidShippingForm,
  setIsPaymentByPaypal,
  setIsSMSConsent,
  setIsEmailConsent,
} = commonSlice.actions;

export default commonSlice.reducer;
